module.exports = __webpack_public_path__ + "img/c-en-03.de2fe4f7.png";